import { useState } from 'react';
import firebaseStore from '@client/stores/firebaseStore';
import webViewStore from '@client/stores/webViewStore';
import { useAutorun } from '@client/clientUtils/mobxUtil';

export const useFcmToken = () => {
    const [isSent, setIsSent] = useState(false);

    useAutorun(() => {
        if (isSent) {
            return;
        }

        // 웹뷰가 처음 로드되었을 때, 로그인 상태이면 토큰을 저장해준다
        if (webViewStore.isInitialized && webViewStore.isWebView && firebaseStore.isInitialized) {
            (async () => {
                await firebaseStore.waitUntilAuthReady();
                await firebaseStore.firebaseAuthStore?.saveFcmTokenToServer();

                setIsSent(true);
            })();
        }
    }, [isSent]);
};
